<template lang="pug">
v-container(fluid).user-delete-form
  .title.error--text 確定重設密碼？
  .content.my-3
    p 姓名：{{ user.displayName }}
    p 區域：{{ user.region | regionFilter }}
    p 編號：{{ user.number }}
    p 地址：{{ user.address }}
    p uid：{{ user.uid }}
  form-actions(
    :loading="formMixin_loading"
    @cancel="$emit('cancel')"
    @submit="submit") {{ formMixin_message }}
  check-dialog(:open="checkDialog"
    title="重設成功"
    @check="$emit('update-succeed')")
</template>
<script>
import { db } from "@/firebase";
import { formMixin } from "@/mixins";
import CheckDialog from "@/components/core/CheckDialog.vue";

export default {
  name: "PasswordResetForm",
  mixins: [formMixin],
  components: {
    CheckDialog
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      checkDialog: false,
      password: "00000000"
    };
  },
  methods: {
    async submit() {
      const res = await this.formMixin_submit(
        ["password"],
        "put",
        `auth/${this.user.uid}/password`
      );

      if (res.succeed) {
        this.checkDialog = true;
      }
    }
  }
};
</script>
